import React, { Component } from "react";
import "../css/Header.css";

class ToxicNav extends Component {
  constructor(props) {
    super(props);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    var navHeight = document.getElementById("toxiccitynav").scrollHeight;
    document.getElementById("root").style.paddingTop = navHeight + "px";
  }

  componentDidMount() {
    // setTimeout(function () {
    //     var navHeight = document.getElementById('toxiccitynav').scrollHeight;
    //     document.getElementById("root").style.paddingTop = navHeight + "px";
    // }, 100);
    window.addEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
      <div id="toxiccitynav" className="navbar">
        <div className="philly-logo">
          <a href="http://www.philly.com">
            <img
              className="philly-logo-img"
              src="https://media.inquirer.com/storage/inquirer/projects/inquirer-logo-desktop-white.png"
              alt=""
            />
          </a>
        </div>

        <div className="titlesection">
          <div>
            <a
              href="http://www.philly.com/toxiccity"
              className="toxic-logo-section"
            >
              <div className="proSig">Toxic City</div>
              <div className="proSigLogo">
                <img
                  src="https://media.inquirer.com/images/ToxicCityLogo.png"
                  alt=""
                />
              </div>
              <div className="proSigPart">Sick Schools</div>
            </a>
          </div>
        </div>

        <div className="toxic-nav-section">
          <div className="custom-social-share">
            <a
              href="http://www.facebook.com/sharer.php?u=https%3A//media.inquirer.com/toxic-city/lead-poisoning-paint-asbestos-mold-asthma-philadelphia-schools-map-search-tool.html"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="share-facebook"
              className="shareBtn faceb"
            >
              &zwnj;
            </a>
            <a
              href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fmedia.inquirer.com%2Ftoxic-city%2Flead-poisoning-paint-asbestos-mold-asthma-philadelphia-schools-map-search-tool.html&text=Toxic%20City%3A%20School%20Checkup"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="share-twitter"
              className="shareBtn twit"
            >
              &zwnj;
            </a>
            <a
              href="mailto:?subject=Toxic City: School Checkup&body=See the tool here: https%3A//media.inquirer.com/toxic-city/lead-poisoning-paint-asbestos-mold-asthma-philadelphia-schools-map-search-tool.html"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="share-email"
              className="shareBtn email"
            >
              &zwnj;
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ToxicNav;



// WEBPACK FOOTER //
// ./src/components/ToxicNav.js